;globalThis["_sentryRewritesTunnelPath"] = "/sen";globalThis["SENTRY_RELEASE"] = {"id":"52bb444c23f9f3ca9e049d7ec3ea803805de543d"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/playlist/:playlistId\",\"regex\":\"^/playlist/([^/]+)$\",\"paramNames\":[\"playlistId\"],\"hasOptionalPrefix\":false},{\"path\":\"/changelog/:slug\",\"regex\":\"^/changelog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/embed/playlist/:playlistId\",\"regex\":\"^/embed/playlist/([^/]+)$\",\"paramNames\":[\"playlistId\"],\"hasOptionalPrefix\":false},{\"path\":\"/playlist/:playlistId/song/:songId\",\"regex\":\"^/playlist/([^/]+)/song/([^/]+)$\",\"paramNames\":[\"playlistId\",\"songId\"],\"hasOptionalPrefix\":false},{\"path\":\"/song/:songId\",\"regex\":\"^/song/([^/]+)$\",\"paramNames\":[\"songId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account\"},{\"path\":\"/admin\"},{\"path\":\"/dev\"},{\"path\":\"/dev/audio-harness\"},{\"path\":\"/early-access\"},{\"path\":\"/home\"},{\"path\":\"/new\"},{\"path\":\"/playlists\"},{\"path\":\"/support\"},{\"path\":\"/upload\"},{\"path\":\"/auth/recover\"},{\"path\":\"/register\"},{\"path\":\"/signin\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/changelog\"},{\"path\":\"/demo\"},{\"path\":\"/landing\"}],\"isrRoutes\":[\"/changelog/:slug\"]}";import { posthog } from '@src/analytics'
import { browserTracingIntegration, init, captureRouterTransitionStart } from "@sentry/nextjs";
import { config } from "@lib/utils/config";
import { sentryBeforeSend, posthogBeforeSend } from "@lib/utils/ignoredErrors";

if (config.sentryEnabled) {
  const environmentString =
    config.environment == "preview" ? `${config.environment}-${config.branch}` : config.environment;

  init({
    dsn: config.sentryDsnUrl,
    environment: environmentString,
    integrations: (defaultIntegrations) => [...defaultIntegrations, browserTracingIntegration()],
    tracesSampleRate: 1.0,

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Filter out benign/unactionable errors before they are sent to Sentry.
    // Uses the same shared ignore list as PostHog before_send and reportError().
    beforeSend: sentryBeforeSend,
  });
}

if (config.posthogEnabled) {
  posthog.init(config.posthogKey, {
    api_host: "https://p.trackshare.app",
    ui_host: "https://us.posthog.com",
    defaults: '2025-05-24',
    capture_exceptions: true, // This enables capturing exceptions using Error Tracking
    debug: process.env.NODE_ENV === "development",
    disable_session_recording: process.env.NODE_ENV === "development",
    __add_tracing_headers: ["trackshare.app", "development.trackshare.app", "staging.trackshare.app"],

    // Filter out benign/unactionable errors before they are sent to PostHog.
    // Uses the same shared ignore list as Sentry beforeSend and reportError().
    before_send: posthogBeforeSend,
  });
}

export const onRouterTransitionStart = captureRouterTransitionStart;
